if (!customElements.get('l-compare-products')) {
	customElements.define(
		'l-compare-products',
		class LTACompareProducts extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Elements
				this.productSelectEl = this.querySelector('[data-product-selects]')
				this.carouselEl = this.querySelector('l-swiper-carousel')
				this.productSlideEls = this.querySelectorAll('[data-product-slide]')
				this.productCountLabelEl = this.querySelector('[data-product-count]')

				// Set up events
				const onSelectDebounce = debounce(this.onSelect.bind(this), 500)
				this.productSelectEl.addEventListener('change', onSelectDebounce)
			}

			onSelect(e) {
				// Adding loading class
				this.carouselEl.classList.add('is-loading')
				this.carouselEl.slideTo(0)

				// Toggle all selected products
				const selectedProducts = Array.from(this.productSelectEl.querySelectorAll('input:checked'))
					.filter((select) => select.checked)
					.map((select) => select.value)

				this.productCountLabelEl.innerHTML = selectedProducts.length == 0 ? '' : `(${selectedProducts.length})`

				this.productSlideEls.forEach((slide) => {
					const productId = slide.getAttribute('data-product-slide')

					slide.classList.toggle('is-hidden', selectedProducts.length > 0 && !selectedProducts.includes(productId))
				})

				// Restart carousel
				this.carouselEl.setupCarousel()

				// Removing loading class
				debounce(() => {
					this.carouselEl.classList.remove('is-loading')
				}, 500)()
			}
		}
	)
}

